import Vue from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueRouter from "vue-router";
import router from "./router";
import "./assets/css/reset.css";
import "./assets/css/common.scss";

Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.config.productionTip = false;
Vue.prototype.openNew = function (url) {
    window.open(url);
}

new Vue({
    router,
    render: (h) => h(App),
}).$mount("#app");
